import { useGermanStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/German/hooks/useGermanStatusBoard';
import MaskInput from 'components/MaskedInput';
import { unMaskInputValue } from 'utils/helpers';
import { useStatusBoard } from 'features/Croptimizer/screen/1Board/components/BoardSteps/components/1Status/Standart/hooks/useStatusBoard';

type CurrentStatusFieldProps = {
  isGerman?: boolean;
  titleHidden?: boolean;
  withButtons?: boolean;
};

const CurrentStatusField = ({ isGerman = false, titleHidden = false, withButtons = false }: CurrentStatusFieldProps) => {
  const {
    setCurrentPh,
    errorCurrent,
    errorTarget,
    cleancurrentph,
  } = isGerman ? useGermanStatusBoard() : useStatusBoard();

  return (
    <div>
      <MaskInput
        className="w-full h-[48px]"
        titleClassName="top-[-9px] left-[8px]"
        title={titleHidden ? '' : 'pH'}
        onChange={setCurrentPh}
        value={unMaskInputValue(cleancurrentph)}
        integerLimit={1}
        decimalLimit={2}
        redBorder={errorTarget.length > 0 || errorCurrent.length > 0}
        withButtons={withButtons}
        suffix={titleHidden ? ' pH' : ''}
        enforceDecimalPlaces={true}
        isBlueBg
      />
      <div className="text-[#FF3B30] text-xs ml-1 mt-1 mt-0 h-2">
        {errorCurrent.length > 0 && <div> {errorCurrent}</div>}
      </div>
    </div>
  );
};

export default CurrentStatusField;
